import { V2Font } from './v2/foundation';

/**
 * 레거시 타이포 토큰 → v2 Tingle DS 타이포(V2Font) 매핑 적용.
 * (Figma "구 시스템 → Tingle DS 타이포 매핑" node 547-2, 51종 → 15종)
 *
 * 기존 `theme.font.<key>`를 소비하는 ~376개 파일을 건드리지 않고, 여기서 각 레거시 키를
 * 대응하는 V2Font 토큰으로 재지정한다. 버블챗·팅글 공용(폰트는 브랜드 무관 = Pretendard).
 * ⚠ 크기/웨이트 변동 항목이 있어 적용 화면 QA 필요(매핑 시안 ⚠ 참고).
 */
const f = V2Font.font;

export const BDSFont = {
  fontFamily: V2Font.fontFamily,
  font: {
    // Head1·2(36/32) → Display/Medium(32)
    head1_ex: f.display.medium,
    head1_sb: f.display.medium,
    head2_ex: f.display.medium,
    head2_sb: f.display.medium,
    // Head3(26/28) → Display/Small(26)
    head3_bw: f.display.small,
    // Head4(24) → Title/Large(22)
    head4_b: f.title.large,
    head4_sb: f.title.large,
    head4_rank: f.title.large,
    // Head5(20) → Title/Large(22)
    head5_b: f.title.large,
    head5_sb: f.title.large,
    head5_m: f.title.large,
    head5_r: f.title.large,
    // Head6(18) → Title/Medium(18)
    head6_b: f.title.medium,
    head6_sb: f.title.medium,
    head6_m: f.title.medium,
    head6_r: f.title.medium,
    // Body1/B·SB(16) → Title/Small(16) · Body1/M·R(16) → Body/Large(16)
    body1_b: f.title.small,
    body1_sb: f.title.small,
    body1_m: f.body.large,
    body1_r: f.body.large,
    // Body2(15): B·SB → Body/Strong(13) · M·R → Body/Medium(14)
    body2_b: f.body.strong,
    body2_sb: f.body.strong,
    body2_m: f.body.medium,
    body2_r: f.body.medium,
    // Body3(14): SB → Body/Strong(13) · M·R → Body/Medium(14)
    body3_sb: f.body.strong,
    body3_m: f.body.medium,
    body3_r: f.body.medium,
    // Body4(13): SB → Body/Strong(13) · M·R → Body/Small(13)
    body4_sb: f.body.strong,
    body4_m: f.body.small,
    body4_r: f.body.small,
    // caption1(12): B·SB → Caption/Large(12) · M·R → Body/XSmall(12)
    caption1_b: f.caption.large,
    caption1_sb: f.caption.large,
    caption1_m: f.body.xsmall,
    caption1_r: f.body.xsmall,
    // caption2(11) → Caption/Medium(11)
    caption2_sb: f.caption.medium,
    caption2_m: f.caption.medium,
    caption2_r: f.caption.medium,
    caption2_underline: {
      ...f.caption.medium,
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
      textDecorationSkipInk: 'none',
      textDecorationThickness: 'auto',
      textUnderlineOffset: 'auto',
      textUnderlinePosition: 'from-font',
    },
    // caption3(10): SB → Caption/Small(10) · R → Caption/Metric(10/500)
    caption3_sb: f.caption.small,
    caption3_r: f.caption.metric,

    /**
     * v2 토큰 네이밍 직접 노출 — **순수 추가**다(위 레거시 키는 하나도 건드리지 않는다).
     *
     * 색상은 이미 `theme.color.brand.*` 처럼 v2 그룹을 그대로 노출하고 있는데(theme/index.ts)
     * 폰트만 레거시 네이밍에 갇혀 있어, 레거시에 대응이 없는 토큰(`caption.mediumRegular` 등)을
     * 쓸 방법이 없었다. CLAUDE.md 의 "신규/변경 컴포넌트는 v2 토큰 이름을 사용" 규칙에 맞춘다.
     *
     * 레거시 키는 전부 접미사형(`caption1_b`·`body4_r`)이라 그룹명과 충돌하지 않는다.
     * 기존 코드는 그대로 두고, **새로 만들거나 고치는 컴포넌트만** 이쪽을 쓴다.
     */
    display: f.display,
    title: f.title,
    body: f.body,
    caption: f.caption,
  },
} as const;
